export default __webpack_public_path__ + "img/b6c19e05ecdde076c331e327f8b09ee5.png";